import Vue from 'vue'
import Router from 'vue-router'
import store from "@/store";

Vue.use(Router)

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  mode: 'history',
  routes: [
    {
        path: "/login",
        name: "login",
        component: () => import("views/login/index.vue"),
    },
    {
            path: '/',
            name: 'index',
            component: () => import('views/index.vue'),
            children: [
                {
                    path: '/ceshi',
                    name: 'ceshi',
                    component: () => import('views/message/ceshi.vue')
                },
                {
                    path: '',
                    name: 'chart',
                    component: () => import('views/message/chart.vue')
                },
                {
                    path: '/chart',
                    name: 'chart',
                    component: () => import('views/message/chart.vue')
                },
                {
                    path: '/ssoLogin',
                    name: 'ssoLogin',
                    component: () => import('views/sso/ssoLogin.vue')
                },
                {
                    path: '/mail',
                    name: 'mail',
                    component: () => import('views/message/mailMessage.vue')
                },
                {
                    path: '/sms',
                    name: 'sms',
                    component: () => import('views/message/smsMessage.vue')
                },
                {
                    path: '/qw',
                    name: 'qw',
                    component: () => import('views/message/qwMessage.vue')
                },
                {
                    path: '/msgTemplate',
                    name: 'msgTemplate',
                    component: () => import('views/message/template.vue')
                },
                {
                    path: '/business',
                    name: 'business',
                    component: () => import('views/message/businessMessage.vue')
                },
                {
                    path: '/sendMail',
                    name: 'sendMail',
                    component: () => import('views/message/sendMail.vue')
                },
                {
                    path: '/group',
                    name: 'group',
                    component: () => import('views/message/group.vue')
                },
                {
                    path: '/themeConfig',
                    name: 'themeConfig',
                    component: () => import('views/message/themeConfig.vue')
                },
            ]
        }
  ]
})

router.beforeEach((to, from, next) => {
  const hasToken = store.getters.jwtToken;
  if (!hasToken && to.name !== "login") {
    next({ name: "login" });
    return;
  }
  if (hasToken && to.name === "login") {
    next({ path: "/" });
    return;
  }
  next();
});

export default router;
